import React from "react";
import useObjectInput from "../../../../../hooks/useObjectInput";
import "./threeDot.css";

/**
 * A functional component that renders a dropdown menu with ellipsis (...) as a trigger.
 * The dropdown displays a list of items passed to it, and highlights items based on the active object.
 * items - The array of items to be displayed in the dropdown.
 * hideLastCap - A flag to determine if the last item's ">" should be hidden.
 */
function ThreeDotDropDown({ items, hideLastCap }) {
  // State to control the visibility of the dropdown menu
  const [isDropdownVisible, setDropdownVisible] = React.useState(false);
  
  const { highlightData, setActiveObjectId } = useObjectInput();

  // Function to toggle the visibility of the dropdown menu
  const toggleDropdown = () => {
    setDropdownVisible(!isDropdownVisible);
  };

  // Function to determine the highlight style based on the active object
  const getHighlightStyle = () => {
    let styles = {};
    // Check if any item is the active object and apply red background
    if (items.some((obj) => obj.id === highlightData.objectId)) {
      styles = { background: "red" };
    }
    // Check if any item is a dependency of the active object and apply yellow background
    if (items.some((obj) => highlightData.dependenciesId.includes(obj.id))) {
      styles = { background: "#fac711" };
    }
    return styles;
  };

  return (
    <>
      {items.length > 0 && (
        <span
          className="hover-dropdown"
          onMouseEnter={toggleDropdown}
          onMouseLeave={toggleDropdown}
        >
          <span className="hover-trigger px-5 cp" style={getHighlightStyle()}>
            ...
          </span>

          {isDropdownVisible && (
            <ul className="dropdown-content">
              {items.map((item) => (
                <li id={item.id} key={item.id} onClick={setActiveObjectId}>
                  <p
                    id={item.id}
                    style={
                      item.id === highlightData.objectId
                        ? { background: "red" }
                        : {}
                    }
                    className="cp"
                  >
                    {item.name}
                  </p>
                </li>
              ))}
            </ul>
          )}
        </span>
      )}
      {!hideLastCap && <span className="cursor-default px-5">{">"}</span>}
    </>
  );
}

export default ThreeDotDropDown;